import * as React from 'react';
import { Box } from '@mui/material';

interface IProps {
    validateForm: () => void;
    initialValues: any;
}

export const FormikModifierWrapper: React.FC<React.PropsWithChildren<IProps>> = ({
    children,
    initialValues,
    validateForm
}) => {
    React.useEffect(() => {
        validateForm();
    }, [initialValues, validateForm]);

    return (
        <Box height="0" display="flex" flex={1}>
            {children}
        </Box>
    );
};
